import { errorMessage } from "../types"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { signOut } from "../api/auth"

export default function SignOutButton() {
  const { logout } = useAuth()
  const navigate = useNavigate()
  const [signingOut, setSigningOut] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSignOut() {
    if (signingOut) return
    setSigningOut(true)
    setError(null)
    try {
      await signOut()
      logout()
      void navigate("/")
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setSigningOut(false)
    }
  }

  return (
    <div>
        <button
          onClick={() => {
            void handleSignOut()
          }}
          disabled={signingOut}
          className="min-h-11 min-w-11 px-3 text-sm text-gray-500 hover:text-gray-900 transition-colors disabled:opacity-50"
        >
          {signingOut ? "Signing out..." : "Sign out"}
        </button>
        {error && (
          <p role="alert" className="w-full text-right text-sm text-red-600">
            {error}
          </p>
        )}
    </div>
  )
}
